<template>
  <div>
    <div class="bg-white">
      <Row :gutter="10">
        <Col span="6">
          <TuboDist v-model="searchParams.dist6" dict-name="dist.support" :clearable="true" @on-change="search"></TuboDist>
        </Col>
        <Col span="6">
          <Input v-model="searchParams.search" enter-button="查询" placeholder="请输入刻章店名称"
                 @on-enter="search" clearable></Input>
        </Col>
        <Col span="6">
          <Button :loading="searching" @click="search" type="success" ghost>查询</Button>
        </Col>
      </Row>

      <Row :gutter="10">
        <Col :span="12" class="m-t-10" v-for="(item, index) in dataPages.content" :key="index">
          <block-maker :item="item" :selected="selected" @click.native="select(item)"></block-maker>
        </Col>
      </Row>
      <div class="text-r p-15">
        <Page :total="dataPages.totalElements" :current="dataPages.number+1" show-elevator show-total
              :page-size="20" size="small" @on-change="search"></Page>
      </div>
      <div class="m-t-20 text-c">
        <Button type="primary" @click="saveMaker" class="m-r-10">选定</Button>
        <Button @click="$router.go(-1)">取消</Button>
      </div>
    </div>

  </div>
</template>

<script>
  import {api, http} from '@/libs'
  import {mapState} from 'vuex'
  import BlockMaker from '@/views/components/BlockMaker'

  export default {
    components: {BlockMaker},
    data() {
      return {
        searchParams: {dist6: '000000', search: null},
        dataPages: {totalElements: 0, number: 0},
        selected: null,
        searching: false,
      }
    },
    computed: {
      ...mapState({
        currentAic: state => state.order.currentAic
      })
    },
    methods: {
      search(page) {
        if (typeof page !== 'number')
          page = 0
        else
          page = page -1  // 前端page从1开始, 后台从0开始

        let params = {page: page, dist6: this.currentAic.orgUscc.substring(2, 8)}
        let conditions = []

        if (this.searchParams.dist6!=='000000') {
          if (this.searchParams.dist6.substr(2, 4) === '0000')
            conditions.push({op: "startswith", param: "dist6", values: this.searchParams.dist6.substr(0, 2)})
          else if(this.searchParams.dist6.substr(4, 2) === '00')
            conditions.push({op: "startswith", param: "dist6", values: this.searchParams.dist6.substr(0, 4)})
          else
            conditions.push({op: "startswith", param: "dist6", values: this.searchParams.dist6})
        }

        if (this.searchParams.search) {
          conditions.push({op: "contains", param: "name", values: this.searchParams.search})
        }

        if (conditions.length > 0)
          params.jsonConditions = JSON.stringify({op: "and", elements: conditions})

        this.searching = true
        http.get(api.libClient.companyBiz, {params: params}).then(payload => {
          this.dataPages = payload
        }).finally(() => this.searching = false)
      },
      saveMaker() {
        if(this.selected) {
          this.$Modal.confirm({
            title: '确认选定刻章企业',
            content: this.selected.name,
            onOk: () => {
              http.post('/api.cus/v1/gzw/cus/aic/offline', {aicId: this.currentAic.id, makerId: this.selected.id}).then(() => {
                this.$router.push('/custom/samr/list')
              })
            },
            onCancel: () => {
            }
          });
        } else {
          this.$Message.info('请选择刻章企业');
        }
      },
      select(item) {
        this.selected = item
      }
    },
    created() {
      this.search()
    }
  }
</script>

<style lang="less">
</style>
